import { CSSObject } from '@chakra-ui/react';

export const InfoExoticsContainer: CSSObject = {
  bg: 'transparent',
  pl: 10,
  borderBottom: '1px solid rgba(0, 0, 0, 0.30)',
  boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.10)',
};
